import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import api from "../services/api";
import MeuEditor from "../Components/Editor/CKeditor";
import MeuTinyEditor from "./Editor/editor";
const AdicionarRedacaoModal = ({ isOpen, onClose, onSuccess }) => {
  const [titulo, setTitulo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [dificuldade, setDificuldade] = useState("1");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await api.post("/redactions", {
        title: titulo,
        description: descricao,
        difficulty: dificuldade,
      });

      toast({
        title: "Redação adicionada com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      onSuccess?.(); // Atualiza lista
      onClose(); // Fecha modal
      setTitulo("");
      setDescricao("");
      setDificuldade("1");
    } catch (error) {
      toast({
        title: "Erro ao adicionar redação.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Adicionar Redação</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormControl mb={4}>
            <FormLabel>Título</FormLabel>
            <Input
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              required
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Descrição</FormLabel>
            <MeuTinyEditor
              value={descricao ?? " "}
              onChange={(content) => setDescricao(content)}
            />
          </FormControl>

          {/* <FormControl>
            <FormLabel>Dificuldade</FormLabel>
            <Select
              value={dificuldade}
              required
              onChange={(e) => setDificuldade(e.target.value)}
            >
              <option value="1">Iniciante</option>
              <option value="2">Intermediário</option>
              <option value="3">Avançado</option>
            </Select>
          </FormControl> */}
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={handleSubmit}
            colorScheme="blue"
            isLoading={isSubmitting}
            mr={3}
          >
            Salvar
          </Button>
          <Button onClick={onClose}>Cancelar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AdicionarRedacaoModal;
